(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("three"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash", "three"], factory);
	else if(typeof exports === 'object')
		exports["Miew"] = factory(require("lodash"), require("three"));
	else
		root["Miew"] = factory(root["_"], root["THREE"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__535__, __WEBPACK_EXTERNAL_MODULE__698__) => {
return 